import { graphql } from "@server/gql";

export default graphql(/* GraphQL */ `
  query DesignerPageBySlug(
    $locale: String!
    $slug: String!
    $limit: Int!
    $preview: Boolean
    $activeMarkets: [String]
  ) {
    siteinfoCollection(locale: $locale, limit: 1) {
      items {
        ...designerPageSiteinfo
      }
    }
    pageCollection(
      locale: $locale
      where: { slug: $slug }
      limit: $limit
      preview: $preview
    ) {
      items {
        ...designerPage
      }
    }
  }
`);
